import { useMemo, useState } from 'react';

import { BridgeEventMethod, FullMessage } from '@scaleaq/sitecontrol-lib';

import { useBridgeRegistration } from '../registerAndSubscribe';
import { useMultiSensorEventSubscription } from './useGetSensorsDataByEventAndIds/useMultiSensorEventSubscription.ts';

/**
 * Get sensor data by event and ids
 * @param ids The ids of the inventory items
 * @param eventName e.g. "GioChannelChanged"
 */
export const useGetSensorsDataByEventAndIds = <T>(ids: string[], eventName: string) => {
  const [results, setResults] = useState<{ [key: string]: T }>({});

  const listenerId = useMemo(
    () => `useGetSensorsDataByEventAndIds-${eventName}-${ids.join('-')}`,
    [eventName, ids]
  );
  // Always, first register the event handler
  useBridgeRegistration({
    bridgeEventMethod: BridgeEventMethod.FullMessage,
    eventCallback: (message: FullMessage) => {
      const { id, listenerIds } = message;
      // if (eventName !== messageEventName) return;
      if (listenerIds && !listenerIds.includes(listenerId)) {
        return;
      }
      setResults(prev => {
        return {
          ...prev,
          [id]: message.data as T,
        };
      });
    },
  });

  // Then subscribe to the event(s)
  const { isLoading } = useMultiSensorEventSubscription(ids, eventName, listenerId);

  return { results, isLoading };
};
